export enum ExternalReferenceNumberType {
    InvoiceReferenceNumber = 'InvoiceReferenceNumber',
    ContractAccountNumber = 'ContractAccountNumber'
}
